import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export const StickyAlertBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-navy text-brand-gold py-3 px-4 shadow-md" data-id="element-211">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-212">
        <div className="flex items-center gap-3 flex-1 justify-center" data-id="element-213">
          <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-214" />
          <p className="text-sm md:text-base font-medium text-center" data-id="element-215">
            <span className="font-bold" data-id="element-216">⚠️ ALERTA:</span> Tu bebé NO debería
            despertarse más de 3 veces por noche.
            <a href="https://www.rutinaspracticas.com/cart/52836173414722:1" onClick={trackAddToCart} className="ml-2 underline hover:text-white transition-colors" data-id="element-217">
              Descubre por qué.
            </a>
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-brand-gold hover:text-white transition-colors flex-shrink-0" aria-label="Cerrar alerta" data-id="element-218">
          <X className="w-5 h-5" data-id="element-219" />
        </button>
      </div>
    </div>;
};